import { Spin } from 'antd';
import { Suspense } from 'react';
import './style.scss';

export interface SuspenseWrapProps {
  component: React.ReactNode;
}

const SuspenseWrap = (props: SuspenseWrapProps) => {
  return (
    <Suspense
      fallback={
        <div className="suspense-loading">
          <Spin size="large" />
        </div>
      }
    >
      {props.component}
    </Suspense>
  );
};

export default SuspenseWrap;
